module.exports = __webpack_public_path__ + "assets/images/ba207dbae209177ea592bc765c40bb61.png";